module.exports = __webpack_public_path__ + "img/IE-desktop-image-404@1440.0a181f65.png";